import React from 'react'
import './styles/home.css';
import { Link } from "react-router-dom";

const GameHomepage = () => {
    return (
        <div id='games-box'>
            <div id='games-title'>
                <img src={process.env.PUBLIC_URL + 'images/controller.png'} className='game-icon'></img>
                <h2>GAMES</h2>
                <img src={process.env.PUBLIC_URL + 'images/dice.png'} className='game-icon'></img>
            </div>

            <div id='games-homepage'>
                <div id='games-container'>
                    <div className='game-card-homepage'>
                        <div className='game-card-img'>
                            <img src={process.env.PUBLIC_URL + 'images/tic-tac-toe.jpg'}></img>
                        </div>
                        <div className='game-card-info'>
                            <h2>Tic Tap Turn</h2>
                            <p>Take on someone in attendance or play solo in our one-of-a-kind Tic Tac Toe game while you wait between performances! Forget X's and O's—this time, it's all about competing soloists. Let the fun begin!</p>
                            <Link style={{ textDecoration: 'none', width: '100%' }} to='/tictactoe'><button className='play-game gold-gradient-wshimmer'>Play Game</button></Link>
                        </div>
                    </div>
                    <div className='game-card-homepage'>
                        <div className='game-card-img'>
                            <img src={process.env.PUBLIC_URL + 'images/crossword2.jpg'}></img>
                        </div>
                        <div className='game-card-info'>
                            <h2>Crossword Puzzle</h2>
                            <p>Get ready to have some fun! Try our engaging crossword puzzle, crafted to entertain and challenge your show choir knowledge during performance breaks at today’s competition. Can you solve them all?</p>
                            <Link style={{ textDecoration: 'none', width: '100%' }} to='/crossword'>
                                <button className='play-game gold-gradient-wshimmer'>Play Game</button>
                            </Link>

                        </div>
                    </div>
                    <div className='game-card-homepage'>
                        <div className='game-card-img' style={{ backgroundColor: '#7E047F' }}>
                            <img src={process.env.PUBLIC_URL + 'images/trivia.jpg'}></img>
                        </div>
                        <div className='game-card-info'>
                            <h2>Show Choir Trivia</h2>
                            <p>Step into the spotlight with our show choir trivia game! Test your knowledge, compete with friends, or take on the challenge solo. Are you ready to prove you're a true show choir superstar?</p>
                            <Link style={{ textDecoration: 'none', width: '100%' }} to='/trivia'>
                                <button className='play-game gold-gradient-wshimmer'>Play Game</button>
                            </Link>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GameHomepage
